<template>
  <div>
    <v-toolbar>
      <v-toolbar-title @click="$router.push('/')">
        <img
          style="margin-top: 8px"
          src="https://static.paymentiq.io/logo/PaymentIQ_Logomark_Black.svg"
          width="150px"
          alt="PaymentIQ logo"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        @click="reloadCashierMutation"
        variant="outlined"
        class="theme-main-color mr-3"
        size="small"
        rounded
      >
        <v-icon size="small">mdi-reload</v-icon>
      </v-btn>

      <v-btn @click="menuClick" icon>
        <v-icon style="color: #000000">mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'Small-header',
  props: {
    menuClick: { type: Function, required: true }
  },
  methods: {
    ...mapMutations(['reloadCashierMutation'])
  }
}
</script>

<style></style>
